import styled, { keyframes } from "styled-components";

import bg3 from "img/bg3.png";

const opasityFrames = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
`;

export default styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-image: ${({ bgImage }) =>
    `linear-gradient(180deg, rgba(8, 15, 26, 0.59) 0%, rgba(17, 17, 46, 0.46) 100%), url(${
      bgImage || bg3
    })`};
  background-repeat: no-repeat;
  background-size: cover;
  animation-name: ${opasityFrames};
  animation-duration: 2s;
  animation-timing-function: ease;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-play-state: running;
`;
